import Base from './base';

class REST extends Base {

}

export default REST;
